// "ResizeObserver loop completed with undelivered notifications" fires when an observer
// callback changes the layout of what it observes, so a new resize is queued while the
// browser is still delivering the current batch.
//
// The observer we hit belongs to smooth-scrollbar (initialized on #sidebar-scrollbar in
// pluginInit -> core.index): its callback runs scrollbar.update(), which re-measures and
// writes sizes on the observed element. Closing a modal removes the `modal-open` padding
// bootstrap-vue puts on <body>, the sidebar changes width, and the loop is reported.
//
// Running the callback in the next animation frame moves those writes out of the delivery
// cycle, so the follow-up resize is a new batch instead of an undelivered notification.
const NativeResizeObserver = window.ResizeObserver

if (NativeResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor (callback) {
      let frame = null

      super((entries, observer) => {
        if (frame) {
          window.cancelAnimationFrame(frame)
        }

        frame = window.requestAnimationFrame(() => {
          frame = null
          callback(entries, observer)
        })
      })
    }
  }
}
